module.exports = __webpack_public_path__ + "static/media/wo.56a6d836.png";